(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/communication-settings-panel.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/communication-settings-panel.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useState
} = React;
const {
  putCustomersSettingsAsync
} = svs.myProfile.react.shared.customerSettingsService;
const {
  clearAllUrlParam,
  makeSetting,
  getCAndI
} = svs.myProfile.react.shared.helpers;
const {
  Form
} = svs.ui.reactForm;
const {
  trackListChanges
} = svs.myProfile.react.shared.tracking;
const {
  showCustomersOldLinkError,
  showSettingsTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  CheckboxItem
} = svs.myProfile.react.shared.components;
const {
  useCustomerSettings
} = svs.myProfile.react.shared.hooks;
const {
  setPlayerSettingsData
} = svs.myProfile.react.store.pd.actions;
const {
  backendName,
  titles
} = svs.myProfile.constants;
const {
  Advertising,
  MarketResearch,
  CommunicationSettingsSkeleton
} = svs.myProfile.react.pages.communicationSettings.communicationSettings.components;

const CommunicationSettingsPanel = () => {
  const dispatch = ReactRedux.useDispatch();
  const {
    playerSettings
  } = ReactRedux.useSelector(state => state.playerDetails);
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  const [shouldShowApiError, setShouldShowApiError] = useState(false);
  const [hasApiErrorShowed, sethasApiErrorShowed] = useState(false);
  const [cAndI, setCAndI] = useState({
    c: '',
    i: ''
  });
  useCustomerSettings(setShouldShowApiError);
  useEffect(() => {
    if (shouldShowApiError && !hasApiErrorShowed) {
      sethasApiErrorShowed(true);
      showSettingsTechnicalError();
    }
  }, [shouldShowApiError, hasApiErrorShowed]);
  useEffect(() => {
    const getData = async () => {
      var _svs$my_profile_react;
      svs.myProfile.logger.debug("**** Player isPlayerLoggedIn: ".concat(isPlayerLoggedIn ? 'Yes' : 'No'));
      const unInLoggedData = (_svs$my_profile_react = svs.my_profile_react.data) === null || _svs$my_profile_react === void 0 ? void 0 : _svs$my_profile_react.communication_settings_react;
      svs.myProfile.logger.debug('get svs.myProfile.data?.communication_settings_react:');
      if (unInLoggedData && unInLoggedData.dataError) {
        clearAllUrlParam();
        showCustomersOldLinkError();
      }
      if (unInLoggedData && unInLoggedData.data) {
        setCAndI(getCAndI());
        dispatch(setPlayerSettingsData(unInLoggedData));
      }
    };
    getData();
  }, [isPlayerLoggedIn]);
  const handleCheckbox = async id => {
    svs.myProfile.logger.debug("**** main handleOnChange id: ".concat(id));
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), {}, {
      [id]: !playerSettings[id]
    });
    const {
      c,
      i
    } = cAndI;
    try {
      const {
        status,
        error
      } = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])], c, i);
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackListChanges(newPlayerSettingsData, playerSettings, 'communication', titles.NEWS);
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  return React.createElement(Form, null, !playerSettings && React.createElement(CommunicationSettingsSkeleton, null), playerSettings && React.createElement(React.Fragment, null, React.createElement(Advertising, null, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxItem, {
    id: backendName.MARKETING_EMAIL,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "E-post"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxItem, {
    id: backendName.MARKETING_SMS,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "SMS"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxItem, {
    id: backendName.MARKETING_LETTER,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Brev"
  })), React.createElement(CheckboxItem, {
    id: backendName.MARKETING_PUSH,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Notiser i v\xE5r app"
  })), React.createElement(MarketResearch, null, React.createElement(CheckboxItem, {
    id: backendName.SURVEY_PARTICIPATION,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "Ja, ni f\xE5r g\xE4rna fr\xE5ga mig om jag vill delta."
  }))));
};
svs.myProfile.react.pages.communicationSettings.communicationSettings.CommunicationSettingsPanel = CommunicationSettingsPanel;

 })(window);